import { render, staticRenderFns } from "./SubmitForm20.vue?vue&type=template&id=1d657a58&scoped=true"
import script from "./SubmitForm20.vue?vue&type=script&lang=ts"
export * from "./SubmitForm20.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d657a58",
  null
  
)

export default component.exports